import { useCompetitionTypeListQuery } from '../types/queries';
import { Input, SelectProps } from '~/components/Input';
import { BaseFormState } from '~/types/BaseFormState';
import { ForwardedRef, forwardRef } from 'react';
import { HasStyle } from '~/types/HasStyle';

type Props<TFormState extends BaseFormState> = Omit<SelectProps<TFormState>, 'options'> & HasStyle;

function CompetitionTypeSelectElement<TFormState extends BaseFormState>(
  props: Props<TFormState>,
  ref: ForwardedRef<HTMLSelectElement>
) {
  const { data = [], isLoading } = useCompetitionTypeListQuery();

  return (
    <Input.Select
      placeholder={props.placeholder ?? 'Alla tävlingstyper'}
      aria-label={props['aria-label'] ?? 'Tävlingstyp'}
      options={data.map(o => [o.description, o.id])}
      disabled={isLoading}
      ref={ref}
      {...props}
    />
  );
}

export const CompetitionTypeSelect = forwardRef(CompetitionTypeSelectElement) as <TFormState extends BaseFormState>(
  props: Props<TFormState> & { ref?: React.ForwardedRef<HTMLSelectElement> }
) => ReturnType<typeof CompetitionTypeSelectElement>;
